import { Trophy, Check, Swords, MessagesSquare, GraduationCap, ShieldCheck, Zap } from "lucide-react";

export default function FeaturePanel() {
  return (
    <>
      <div className="font-label text-[#1E4FFF] mb-3 tracking-[0.25em]">YOU&apos;RE ABOUT TO UNLOCK</div>
      <h2 className="font-display text-4xl xl:text-5xl mb-8 leading-tight text-[#0B0B12]">
        EVERYTHING YOUR<br />REPS NEED TO WIN.
      </h2>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4" data-testid="feature-groups">
        <FeatureCard
          icon={Trophy}
          title="COMPETE"
          items={[
            "Live leaderboards — daily, weekly, monthly & all-time",
            "Points, levels, streaks & owner-defined badges",
            "Record Holders hall of fame for all-time blowouts",
            "Custom competitions with prizes & live progress",
          ]}
        />
        <FeatureCard
          icon={Swords}
          title="THE ARENA"
          items={[
            "1v1 duels, team wars & squad battles",
            "Live battle scores with win/loss records",
            "Unlockable card frames & trading-card rep profiles",
            "Custom title ladder — Rookie → Closer → whatever you name it",
          ]}
        />
        <FeatureCard
          icon={MessagesSquare}
          title="THE PIT"
          items={[
            "Team chat hub — company channels, group chats & 1:1 DMs",
            "Photos, reactions, polls, replies & 24h Stories",
            "Owner & manager announcements to the whole team",
            "Smart push with @mentions, pinned chats & per-chat mute",
          ]}
        />
        <FeatureCard
          icon={GraduationCap}
          title="TRAIN & COACH"
          items={[
            "Training Academy — modules, lessons & quizzes with XP",
            "AI builds full training modules — lessons + quiz — from a topic",
            "Goal engine with fully custom scoring",
            "Itinerary, calendar & attendance tracking",
          ]}
        />
        <FeatureCard
          icon={ShieldCheck}
          title="OWN THE BUSINESS"
          className="xl:col-span-2"
          items={[
            "Mobile-first sale logging + CSV bulk import",
            "Owner analytics, audit trail & branded emails",
            "Stripe self-serve billing — upgrade, downgrade or cancel anytime",
            "Strict data isolation — your data stays yours, period",
          ]}
        />
      </div>

      <div
        className="mt-6 border border-[#1E4FFF]/40 bg-[#1E4FFF]/[0.06] rounded-sm px-5 py-3.5 flex items-center gap-3"
        data-testid="feature-trial-strip"
      >
        <Zap className="w-4 h-4 text-[#1E4FFF] flex-shrink-0" />
        <span className="text-sm text-[#1E4FFF]">
          <b>30-day free trial.</b> Up to 80 reps · cancel anytime.
        </span>
      </div>
    </>
  );
}

function FeatureCard({ icon: Icon, title, items, className = "" }) {
  return (
    <div className={`border border-[#EDEFF3] bg-white rounded-sm p-5 ${className}`}>
      <div className="flex items-center gap-2.5 mb-3">
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-sm border border-[#1E4FFF]/30 bg-[#1E4FFF]/[0.08]">
          <Icon className="w-3.5 h-3.5 text-[#1E4FFF]" />
        </span>
        <span className="font-label text-[11px] tracking-[0.22em] text-[#0B0B12]">{title}</span>
      </div>
      <ul className={`space-y-2 ${className.includes("col-span-2") ? "xl:grid xl:grid-cols-2 xl:gap-x-6 xl:gap-y-2 xl:space-y-0" : ""}`}>
        {items.map((f, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <Check className="w-3.5 h-3.5 text-[#34C759] mt-[3px] flex-shrink-0" />
            <span className="text-sm text-[#4B5563] leading-snug">{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
